import {Route} from '@angular/router';
import { HbuComponent } from '@app/features/analysis-refactor/pages/analysis-configuration/pages/hbu/hbu.component';

export const HbuRoute :Route[]= [
  {
    path:"",
    component:HbuComponent,
    children:[
      {
        path: 'scenarios-overview',
        loadComponent: () => import('@app/features/analysis-refactor/pages/analysis-configuration/pages/hbu/scenarios-overview/scenarios-overview.component')
      },
      {
        path: 'scenarios-details',
        loadComponent: () => import('@app/features/analysis-refactor/pages/analysis-configuration/pages/hbu/scenarios-details/scenarios-details.component')
      },
    ]
  }
]
